export default "__VITE_ASSET__DlA8P9TT__"